import { useToggle } from '@hooks/useToggle';
import { Button } from 'reactstrap';
import { SurveyTemplateMinData } from '../../types';
import { DelegateTemplateWorkgroupModal } from './DelegateTemplateWorkgroupModal';
import { SurveyWorkgroup } from '@g17eco/types/workgroup';
import { MetricGroup } from '@g17eco/types/metricGroup';

interface Props {
  template: SurveyTemplateMinData;
  metricGroups: MetricGroup[];
  delegatedWorkgroups: SurveyWorkgroup[];
}

export const DelegateTemplateWorkgroupBtn = ({ template, metricGroups, delegatedWorkgroups }: Props) => {
  const [isOpen, toggle] = useToggle();

  return (
    <>
      <Button color='secondary' onClick={toggle} className='ms-auto'>
        <i className='fal fa-users-medical me-2' />
        Delegate workgroup
      </Button>
      <DelegateTemplateWorkgroupModal
        key={`delegate-workgroup-modal-${isOpen}`}
        isOpen={isOpen}
        toggle={toggle}
        template={template}
        metricGroups={metricGroups}
        delegatedWorkgroups={delegatedWorkgroups}
      />
    </>
  );
};
